// extracted by mini-css-extract-plugin
export var content = "_1-3";
export var footer = "_1-4";
export var header = "_1-1";
export var panel = "_1-0";
export var tabsWrapper = "_1-2";